import { Injectable } from '@angular/core'
import { ArtistId } from '../models/artist.model'
import { AngularFireFunctions } from '@angular/fire/compat/functions'
import { Observable } from 'rxjs'
import { Homepages } from '../models/homepages.model'
import * as moment from 'moment'

interface Criteria {
  artistId: ArtistId
  from: string
  to: string
}

@Injectable({
  providedIn: 'root',
})
export class HomepagesGraphService {
  constructor(private functions: AngularFireFunctions) {}

  findHomepagesGraph(artistId: ArtistId, from: Date, to: Date): Observable<Homepages[]> {
    return this.functions.httpsCallable<Criteria, Homepages[]>('findHomepagesGraph')({
      artistId,
      from: moment(from).format('YYYY-MM-DD'),
      to: moment(to).format('YYYY-MM-DD'),
    })
  }
}
